<template>
  <v-container
    id="cobraEdit"
    class="pa-0"
  >
    <v-row>
      <v-col
        cols="12"
      >
        <base-resource-select
          label="Product / Carrier"
          item-text="productCarrier"
          item-value="productCarrierKey"
          bind-text="productCarrier"
          bind-value="productCarrierKey"
          :bind-item="editedItem"
          :error-messages="productCarrierError"
          :fetch-method="getFromProductCarrier"
          :disabled="disabled"
          @change="onProductCarrierChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <base-resource-select
          label="Administering Carrier"
          item-text="carrier"
          item-value="id"
          bind-text="carrier"
          bind-value="carriersAdministeringId"
          :bind-item="editedItem"
          :error-messages="safeFormErrors.CarriersAdministeringId"
          :resource="carrierResource"
          :disabled="disabled"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.sendFilesToProductCarrierEDI"
          :error-messages="safeFormErrors.SendFilesToProductCarrierEDI"
          :disabled="disabled"
          label="Send Files to Product Carrier (EDI)"
          @change="onChange"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.sendInitialNoticesTermsToCobraAdmin"
          :error-messages="safeFormErrors.SendInitialNoticesTermsToCobraAdmin"
          :disabled="disabled"
          label="Send Initial Notices and Terms to Cobra Admin"
          @change="onChange"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-switch
          v-model="editedItem.ratesDiffThanActive"
          :error-messages="safeFormErrors.RatesDiffThanActive"
          :disabled="disabled"
          label="Rates different than active"
          @change="onChange"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'CobraEdit',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      formErrors: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      editedItem: null,

      productCarrierResource: new TroodyApi('oeCobraProductCarrier/'),
      carrierResource: new TroodyApi('carrier/'),
    }),

    computed: {
      safeFormErrors () {
        return this.formErrors || {}
      },

      productCarrierError () {
        let e = null
        if (this.safeFormErrors) {
          e = (this.safeFormErrors.ProductId || this.safeFormErrors.CarrierId)
        }
        return e
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.editedItem = this.value
        const key = this.buildProductCarrierKey()
        if (key) {
          this.editedItem.productCarrierKey = key
        }
      },

      buildProductCarrierKey () {
        let key = null

        if (this.editedItem && this.editedItem.openEnrollmentId && this.editedItem.productId && this.editedItem.carrierId) {
          key = this.editedItem.openEnrollmentId + '_' + this.editedItem.productId + '_' + this.editedItem.carrierId
        }

        return key
      },

      getFromProductCarrier () {
        return this.productCarrierResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      transformItem () {
        this.editedItem.openEnrollmentId = this.openEnrollment.id

        return this.editedItem
      },

      onProductCarrierChange (bindItem, selectedValue) {
        let productId = null
        let carrierId = null

        if (selectedValue) {
          const parts = selectedValue.split('_')
          if (parts.length >= 3) {
            productId = Number(parts[1])
            carrierId = Number(parts[2])
          }
        }

        this.editedItem.productId = productId
        this.editedItem.carrierId = carrierId
        this.onChange()
      },

      onChange () {
        this.transformItem()
        this.$emit('update:value', this.editedItem)
        this.$emit('change', this.editedItem)
      },
    },
  }
</script>
